import { Component, ViewChild, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, NgZone, ElementRef, Renderer2 } from '@angular/core';
//import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorComponent, TableService, MarkdownEditorService } from '@syncfusion/ej2-angular-richtexteditor';
//import { ToolbarService, LinkService, ImageService, HtmlEditorService, TableService } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, MouseEventArgs, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import { saveAs as importedSaveAs } from "file-saver";
import { RequestPropTab } from '../request-prop-tab';
import { HttpService } from '../../../services/http.service';
import { HelperService } from '../../../services/helper.service';
import { Request } from '../../../models/Request/request.model';
import { Util } from '../../../helpers/global.util';
import { UrlParams } from '../../../helpers/url-params';
import * as AppConst from '../../../data/test.data';
import { AuthenService } from '../../../services/authen.service';
import { NotifyService } from '../../../services/notify.service';
import { Subscription } from 'rxjs';
import { Information } from '../../../models/Request/informations';
import { Message } from '../../../models/Request/message';
import { NgForm, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { commandClick } from '@syncfusion/ej2-grids';
import { objBodyMail } from '../../../models/Request/mail.model';

@Component({
    selector: 'informations-tab',
    templateUrl: './informations-tab.html',
    styleUrls: ['./informations-tab.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationsTabComponent extends RequestPropTab implements OnInit {    
    @Output() onChangedData = new EventEmitter<any>();        
    subsNotify: Subscription;
    get AppConst() { return AppConst; }

    message: Message;
    comments: Array<any> = [];
    objMail: objBodyMail = new objBodyMail();

    constructor(cdr: ChangeDetectorRef, public http: HttpService, private notify: NotifyService,
        public helper: HelperService, public auth: AuthenService, public datepipe: DatePipe, private _ngZone: NgZone) {
        super(cdr);
        //this.register_FUNCTION_OnServerEvents();
    }


    ngOnInit() {
    }

    init() {
        this.LoadInformations();
        this.ngRefresh();
        this.subsNotify = this.notify.getMessage().subscribe(msg => {
            if (msg.value == this.requestID.toString()) {
                if (msg.text == 'NewComments') {
                    //this.helper.alertFailed('You have new message.');
                    this.LoadInformations();
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.subsNotify)
            this.subsNotify.unsubscribe();
    }

    LoadInformations(): void {
        console.log('commnets:' + this.requestID);
        this.http.get('api/Request/GetComment/' + this.requestID, res => {            
            this.comments = res.Result;
            this.ngRefresh();
        }, null);
    }

    renderDateColumn(value: Date) {
        return this.datepipe.transform(value, 'dd/MM/yyyy HH:mm');
    }

    onSend(form: NgForm) {
        var data = form.value;
        var comment = data.comment;
        let model = {
            RequestID: this.requestID,
            UserID: 0,
            Comment: comment
        };

        if (!Util.isFieldEmpty(comment)) {
            this.http.save('api/Request/SaveComment', model, res => {

                // reset form
                form.resetForm();
                /*
                // Notification
                this.message = new Message();
                this.message.type = "SEND_NOTIFICATION";
                this.message.to = "all";
                this.message.message = comment;
                this.notificationService.sendMessage(this.message);

                // Refresh Comment
                this.message = new Message();
                this.message.type = "REFRESH_COMMENT";
                this.message.to = "all";
                this.message.message = "";
                this.notificationService.sendTask(this.message);
                */
                this.LoadInformations();
               // this.onSendMail(comment);                              
            }, null);
        }
    }

    onSendMail(commentMsg: string) {
        let Subject = '';
        let toUser = '';
        let ccUser = '';
        if (this.auth.GroupUserCode != 'HS') {
            Subject = 'New message-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserFFM;
            ccUser = this.request.UserSC;
        } else {
            Subject = 'New message-' + this.request.Requestcode + '-' + this.request.RequestTypeName;
            toUser = this.request.UserSC;
            ccUser = this.request.UserFFM;
        } 

        let paramObj =
        {
            RequestID: this.requestID,
            RequestCode: this.request.Requestcode,
            Subject: Subject,
            ToUser: toUser,
            CcUser: ccUser,
            RequestTypeName: this.request.RequestTypeName,
            UserNameInternal: this.request.UserSC,
            DeadlineFFMApproval: this.request.DeadlineFFMApproval,
            DeadlineHSChecking: this.request.DeadlineHScheck,
            DeadlineHSDone: this.request.DeadlineHDdone,
            UrlAddr: window.location.href,
            OtherContent: commentMsg
        };
        this.objMail.set(paramObj);
        if (this.auth.GroupUserCode != 'HS') {
            this.http.post(`api/Util/SCFFMSendComment/`, this.objMail, res => {
                this.helper.alert('Send mail SC/FFM comment success');
            });
        } else {
            this.http.post(`api/Util/HSSendComment/`, this.objMail, res => {
                this.helper.alert('Send mail HS comment success');
            });
        }
    }    
}
